import type { ICard } from "../../cardsSlice";

export const major3Card: ICard = {
    id: "major_3",
    arcana: "major",
    number: 3,
    suit: "major",
    court: "major",
    name: "Императрица",
    nameEn: "The Empress",
    keywords: ["Плодородие", "Забота", "Изобилие"],
    symbolism: [
      "Женщина на троне с венком из звёзд",
      "Скипетр в руке, поле пшеницы, лес",
      "Символ Венеры",
      "Природа вокруг, мягкая поза"
    ],
    symbolismInterpretation:
      "Материнство, женская творческая энергия, соединение с телом и природой",
    archetype: "Великая Мать-Земля, питающая и дающая жизнь",
    psychology: "Принятие, забота о себе и других, созидательное раскрытие чувств",
    upright: {
      personality: "Открытость, эмпатия, щедрость",
      relationships: "Любовь, гармония, плодовитость",
      work: "Проекты с реальным результатом, рост",
      spirituality: "Связь с телом и природой",
      examples: ["Период процветания", "Поддержка", "Взращивание чего-то нового"]
    },
    reversed: {
      meaning: "Застой, излишнее потворство, утрата гармонии с телом",
      nuances: "Избыток комфорта, привязанность к материальному"
    },
    associations: ["Материнство", "Мягкость", "Изобилие", "Природа"],
    combinations: [
      "С Императором — прочный союз и структура",
      "С Жрицей — баланс чувственного и духовного"
    ],
    readingTips: ["Оценить, требуется ли больше заботы", "Не стало ли изобилие самоцелью"],
    selfQuestions: ["Как я проявляю заботу?", "Что я могу взрастить?"]
  };


